import { SVGProps } from 'react'
import { ReactComponent as EmptyPlannedConsultationSvg } from './no_planned_consultation.svg'
import { ReactComponent as DisabledConsultationSvg } from './disabled_consultation.svg'
import { ReactComponent as AmTooltipHelper } from './am_tooltip_helper.svg'
import { ReactComponent as FinessTooltipHelper } from './finess_tooltip_helper.svg'
import { ReactComponent as EmptyExpertise } from './empty-state-expertise.svg'
import { ReactComponent as DisabledExpertise } from './disabled_expertise.svg'
import { useImageStyles } from '../../styles/imageStyles'
import BodyPartMale from './body_m.jpg'
import BodyPartFemale from './body_f.jpg'

export const EmptyStateExpertiseImage = (props: SVGProps<SVGSVGElement>) => {
    const classes = useImageStyles()
    return <EmptyExpertise {...props} className={classes.imageSize} />
}
export const EmptyPlannedConsultationImage = (props: SVGProps<SVGSVGElement>) => {
    const classes = useImageStyles()
    return <EmptyPlannedConsultationSvg {...props} className={classes.imageSize} />
}
export const DisabledConsultationImage = (props: SVGProps<SVGSVGElement>) => {
    const classes = useImageStyles()
    return <DisabledConsultationSvg {...props} className={classes.imageSize} />
}
export const DisabledExpertiseImage = (props: SVGProps<SVGSVGElement>) => {
    const classes = useImageStyles()
    return <DisabledExpertise {...props} className={classes.imageSize} />
}
export const AmTooltipHelperImage = (props: SVGProps<SVGSVGElement>) => <AmTooltipHelper {...props} />
export const FinessTooltipHelperImage = (props: SVGProps<SVGSVGElement>) => <FinessTooltipHelper {...props} />

export const BodyPartMaleUrl = BodyPartMale
export const BodyPartFemaleUrl = BodyPartFemale
export const BodyPartMaleImage = () => <img src={BodyPartMaleUrl} alt="Body part male" />
export const BodyPartFemaleImage = () => <img src={BodyPartFemaleUrl} alt="Body part female" />
